import { Box, BoxProps } from '@mui/system';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '../../translations';

type CompetitionRankingHeaderProps = BoxProps;

export const CompetitionRankingHeader = ({
  sx,
  ...rest
}: CompetitionRankingHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '3rem',
        alignItems: 'center',
        textTransform: 'uppercase',
        fontSize: '0.65rem',
        fontWeight: 'bold',
        backgroundColor: 'background.paper2',
        px: 1,
        ...sx,
      }}
      {...rest}
    >
      <Box
        sx={{
          width: '100%',
          textAlign: 'left',
          paddingLeft: 2,
        }}
      >
        {t(T_KEYS.COMPETITION_RANKING_TEAMS)}
      </Box>
    </Box>
  );
};
